<script>
import moment from 'moment';
import axios from 'axios';

export default {
  methods: {
    hasAccessToPageMixin() {
      const rolesPage = this.$route.meta.roles;
      const rolesUser = this.$store.state.config.userObject.roles;
      let hasAccess = false;

      for (let i = 0; i < rolesUser.length; i++) {
        const roleUser = rolesUser[i];
        if (rolesPage.includes(roleUser)) {
          hasAccess = true;
          break;
        }
      }

      return hasAccess;
    },
    checkForDotEmail(email) {
      if (email && email.replace(/[^@]/g, '').length >= 2) return 'Cannot contain multiple characters of @';
      else if (email && email.includes('.@')) return 'Email cannot contain a dot before the @';
      else return true;
    },
    formatDate(d) {
      return moment.utc(d, 'YYYY-MM-DDTHH:mm').local().format('DD-MMM-YYYY');
    },
    formatDateCustom(d, format) {
      return moment.utc(d, 'YYYY-MM-DDTHH:mm').local().format(format);
    },
    formatDateTime(d) {
      return moment.utc(d, 'YYYY-MM-DDTHH:mm').local().format('DD-MMM-YYYY / hh:mm A');
    },
    formatTime(d) {
      return moment.utc(d, 'YYYY-MM-DDTHH:mm').local().format('hh:mm A');
    },
    isToday(date) {
      const todayFormatted = moment().format('YYYY-MM-DD');
      const dateFormatted = moment.utc(date, 'YYYY-MM-DDTHH:mm').local().format('YYYY-MM-DD');
      if (todayFormatted == dateFormatted) return true;
      else return false;
    },
    isAfterToday(date) {
      const todayFormatted = moment().format('YYYY-MM-DD');
      const dateFormatted = moment.utc(date, 'YYYY-MM-DDTHH:mm').local().format('YYYY-MM-DD');
      if (moment(dateFormatted).isAfter(todayFormatted)) return true;
      else return false;
    },
    isBeforeToday(date) {
      const todayFormatted = moment().format('YYYY-MM-DD');
      const dateFormatted = moment.utc(date, 'YYYY-MM-DDTHH:mm').local().format('YYYY-MM-DD');
      if (moment(dateFormatted).isBefore(todayFormatted)) return true;
      else return false;
    },
    daysBeforeTillToday(date) {
      const todayFormatted = moment().format('YYYY-MM-DD');
      const dateFormatted = moment.utc(date, 'YYYY-MM-DDTHH:mm').local().format('YYYY-MM-DD');
      return moment(dateFormatted).diff(todayFormatted, 'days');
    },
    daysAfterTillToday(date) {
      const todayFormatted = moment().format('YYYY-MM-DD');
      const dateFormatted = moment.utc(date, 'YYYY-MM-DDTHH:mm').local().format('YYYY-MM-DD');
      return moment(todayFormatted).diff(dateFormatted, 'days');
    },
    userHasRole(role) {
      if (!this.$store.state.config.userObject) return;
      const rolesUser = this.$store.state.config.userObject.roles;
      let hasRole = false;
      for (let i = 0; i < rolesUser.length; i++) {
        if (rolesUser[i] == role) {
          hasRole = true;
          break;
        }
      }
      return hasRole;
    },

    async azvNumberAlreadyRegistered(number) {
      return await axios
        .get(`${this.$store.state.baseUrlApiDvg}/healthcheck-restful-api/user-registration/azv/${number}`)
        .then((res) => {
          if (res.status == 200 && res.data) {
            return true;
          } else {
            return false;
          }
        })
        .catch((error) => {
          console.log(error);
          let payload = {
            open: true,
            text: 'Error checking AZV number in database',
            color: 'error'
          };
          this.$store.commit('SET_SNACKBAR', payload);
          return false;
        });
    },
    makeUid(length) {
      var result = '';
      var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }
  }
};
</script>